module.exports = __webpack_public_path__ + "img/product_16.817d5bc.jpg";